var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_676_2917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17195 6L11.172 8H20.002V18H4.00195V6H9.17195ZM10.002 4H4.00195C2.90195 4 2.01195 4.9 2.01195 6L2.00195 18C2.00195 19.1 2.90195 20 4.00195 20H20.002C21.102 20 22.002 19.1 22.002 18V8C22.002 6.9 21.102 6 20.002 6H12.002L10.002 4Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_676_2917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderInactive);
export default __webpack_public_path__ + "static/media/FolderInactive.33a6bc47ed6fad8adbdc250bb21131c9.svg";
export { ForwardRef as ReactComponent };